var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_1935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.033884 4.9871C0.118984 4.72386 0.352465 4.5369 0.628695 4.512L4.38085 4.1713L5.86456 0.698551C5.97396 0.444043 6.22311 0.279297 6.49993 0.279297C6.77676 0.279297 7.02591 0.444043 7.13531 0.699146L8.61901 4.1713L12.3718 4.512C12.6475 4.53749 12.8804 4.72386 12.966 4.9871C13.0516 5.25033 12.9725 5.53906 12.7639 5.72107L9.92776 8.20842L10.7641 11.8924C10.8253 12.1633 10.7201 12.4433 10.4954 12.6058C10.3746 12.6931 10.2332 12.7375 10.0907 12.7375C9.96783 12.7375 9.84593 12.7044 9.73653 12.6389L6.49993 10.7045L3.26453 12.6389C3.02777 12.7813 2.72933 12.7683 2.50507 12.6058C2.28022 12.4428 2.17518 12.1627 2.23638 11.8924L3.0727 8.20842L0.236518 5.72156C0.0279322 5.53906 -0.051713 5.25083 0.033884 4.9871Z",
    fill: "#FAC300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_1935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "matrix(-1 0 0 1 13 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.eb59e1df.svg";
export { ForwardRef as ReactComponent };